import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UseCaseCardComponent from '../components/UseCaseCardComponent';

// Import your icons and images
import detectionLogo from '../image/detection.png';
import target_marketing from '../image/target_marketing.png';
import accounting from '../image/accounting_2.png';
import analytics from '../image/analytics.png';
import audience from '../image/audience.png';
import benchmarking from '../image/benchmarking.png';
import cross_selling from '../image/cross_selling.png';
import liquidity from '../image/liquidity.png';
import key_performance_indicator from '../image/key_performance_indicator.png';
import churn_prediction from '../image/churn_prediction.png';

// Import style utility if it exists
import { Colors } from '../utils/style';

function UseCase() {
  const { t } = useTranslation("useCase");
  const navigate = useNavigate();

  const useCases = [
          {
      title: t('CreditRiskAssessment'),
      description: t('CreditRiskAssessmentDescription'),
      logo: liquidity,
      handleOnClick: () => navigate('/creditRisk'),
    },
    {
      title: t('FraudDetection'),
      description: t('FraudDetectionDescription'),
      logo: detectionLogo,
    },
    {
      title: t('PredictiveAnalyticsCrossSelling'),
      description: t('PredictiveAnalyticsCrossSellingDescription'),
      logo: cross_selling,
    },
    {
      title: t('TargetedMarketing'),
      description: t('TargetedMarketingDescription'),
      logo: target_marketing,
    },
    {
      title: t('RealTimeMonitoring'),
      description: t('RealTimeMonitoringDescription'),
      logo: key_performance_indicator,
    },
    {
      title: t('CustomerInsights'),
      description: t('CustomerInsightsDescription'),
      logo: analytics,
    },
    {
      title: t('MarketAnalysis'),
      description: t('MarketAnalysisDescription'),
      logo: audience,
    },

  ];

  return (
    <Container className="mt-4 mb-4">
      <div className="mb-5 mt-5">
        <h2 style={{ color: Colors.DARK_BLUE }}>{t('UseCases')}</h2>
      </div>
      <Container className="mt-3">
        <Row md={2} xs={1} lg={3} sm={2}>
          {useCases.map((useCase, index) => (
            <Col key={index} style={{ padding: '0.5rem' }}>
              <UseCaseCardComponent
                title={useCase.title}
                description={useCase.description}
                logo={useCase.logo}
                handleOnClick={useCase.handleOnClick}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default UseCase;
